import { tooltipContext } from './chunk-RBTESKWW.js';
import { scopedRaf } from './chunk-Z6A4GYXE.js';
import { hasProvidedContext, useContext } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var Tooltip = class extends Component {
  onAttach(el) {
    if (hasProvidedContext(tooltipContext)) {
      scopedRaf(() => {
        const tooltip = useContext(tooltipContext);
        tooltip.ic(el);
      });
    }
    this.setAttributes({
      position: this.$props.position
    });
  }
};
Tooltip.el = defineElement({
  tagName: "media-tooltip",
  props: { position: "top center" }
});

export { Tooltip };
